<template>
  <div class="auditData_box">
    <el-card shadow="always">
      <div class="auditData_top">
        <el-form
          ref="formInline"
          :inline="true"
          size="medium"
          :model="formInline"
        >
          <el-form-item label="审核时间">
            <my-datePicker
              :scopeDate="formInline.scopeDate"
              @receiveMyDate="receiveMyDate"
            />
          </el-form-item>
        </el-form>
      </div>

      <div class="auditData_title">
        <el-button type="primary" size="medium" @click="openDialog"
          >列表人员管理</el-button
        >
      </div>

      <div class="auditData_table">
        <el-table
          v-loading="loading"
          border
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="nickName" align="center" label="员工姓名">
          </el-table-column>
          <el-table-column prop="num" align="center" label="工单审核次数">
          </el-table-column>
          <el-table-column prop="passNum" align="center" label="工单通过次数">
          </el-table-column>
          <el-table-column prop="rejectNum" align="center" label="审核驳回次数">
          </el-table-column>
          <el-table-column prop="pushNum" align="center" label="推送工单次数">
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <my-transfer ref="myTransferRef" />
  </div>
</template>

<script>
import { getSupportUserStatisticsListPage } from "@/api/refund/index.js";
import myPagination from "@/components/myPagination.vue";
import myDatePicker from "@/components/myDatePicker.vue";
import myTransfer from "@/views/refundStatistic/components/myTransfer.vue";
export default {
  components: { myPagination, myDatePicker, myTransfer },
  data() {
    return {
      loading: false,
      formInline: {
        scopeDate: [],
      },
      tableData: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  mounted() {
    const myDate = new Date();
    const year = myDate.getFullYear(); // 获取当前年份
    const month =
      myDate.getMonth() + 1 < 10
        ? "0" + (myDate.getMonth() + 1)
        : myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
    const day =
      myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate(); // 获取当前日（1-31）
    let time = `${year}-${month}-${day}`;
    this.formInline.scopeDate = [time, time];
    this.getSupportUserStatisticsListPage({
      startDate: time,
      endDate: time,
      page: 1,
      limit: 10,
    });
  },
  methods: {
    async getSupportUserStatisticsListPage(payload) {
      this.loading = true;
      this.$set(this.pageInfo, "page", payload.page);
      this.$set(this.pageInfo, "limit", payload.limit);
      const res = await getSupportUserStatisticsListPage(payload);
      this.tableData = res.data.records || [];
      this.pageInfo.total = Number(res.data.total) || 0;
      this.loading = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getSupportUserStatisticsListPage({
        startDate: this.formInline.scopeDate[0],
        endDate: this.formInline.scopeDate[1],
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    openDialog() {
      this.$refs.myTransferRef.init();
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getSupportUserStatisticsListPage({
        startDate: this.formInline.scopeDate[0],
        endDate: this.formInline.scopeDate[1],
        page: 1,
        limit: payload,
      });
    },
    receiveMyDate(date) {
      this.formInline.scopeDate = date;
      this.getSupportUserStatisticsListPage({
        startDate: this.formInline.scopeDate[0],
        endDate: this.formInline.scopeDate[1],
        page: 1,
        limit: this.pageInfo.limit,
      });
    },
    // 刷新
    refresh() {
      this.getSupportUserStatisticsListPage({
        startDate: this.formInline.scopeDate[0],
        endDate: this.formInline.scopeDate[1],
        page: this.pageInfo.page,
        limit: this.pageInfo.limit,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.auditData_box {
  .auditData_title {
    margin-bottom: 14px;
  }
}
</style>